const upgradeSubscriptionFlowSteps = {
  selectPlan: 'selectPlan',
  selectedPlanSummary: 'selectedPlanSummary',
  upgradeSuccess: 'upgradeSuccess',
}


export default upgradeSubscriptionFlowSteps
